export enum TextEntrySize {
    Normal = "normal",
    Medium = "medium",
    Large = "large",
}
